const state = {
  enviarMensagem: null,
  ultima_mensagem_recebida: null,
  mensagens_recebidas: [],
};

const getters = {
  getUltimaMensagemRecebida(state) {
    return state.ultima_mensagem_recebida;
  },
  getMensagensRecebidas(state) {
    return state.mensagens_recebidas;
  },
};

const mutations = {
  setCallbackEnviarMensagemWebSocket(state, payload) {
    if (state.enviarMensagem !== null) return;
    state.enviarMensagem = payload;
  },
  resetCallbackEnviarMensagemWebSocket(state) {
    state.enviarMensagem = null;
  },
  setUltimaMensagemRecebida(state, payload) {
    state.ultima_mensagem_recebida = payload;
    state.mensagens_recebidas.push(payload);
  },
  enviarMensagem(state, mensagem) {
    if (state.enviarMensagem !== null) {
      state.enviarMensagem(mensagem);
    }
  },
};

const actions = {
  enviarMensagem(context, mensagem) {
    context.commit("enviarMensagem", mensagem);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
